import React from 'react';
import { ListBox as KendoListBox, ListBoxProps as KendoListBoxProps } from '@progress/kendo-react-listbox';
import NoRecordsMessage from '@components-clean/core/grid/no-records-message';
import { useTranslation } from '@hooks/index';

interface ListBoxProps extends KendoListBoxProps {
    hideNoRecordsMessage?: boolean;
}

const ListBox = ({ data, hideNoRecordsMessage, ...rest }: ListBoxProps) => {
    const { t } = useTranslation();

    return (
        <div className="k-pos-relative k-h-full">
            <KendoListBox data={data} {...rest} />
            {!hideNoRecordsMessage && !data.length && (
                <NoRecordsMessage message={t('noDataToDisplay')} className="k-centered" />
            )}
        </div>
    );
};

export default ListBox;
